import { FormStore } from '@roc/feature-app-core';
import {
  createCurrencyField,
} from '../../../components/temp/componentBuiderTemp';
import { observer } from 'mobx-react';


export const CapitalImprovements = observer(({ store }: { store: FormStore }) => {
  return (
    <>
      {createCurrencyField({
        label: "Construction/Reno Spent to Date",
        fieldName: 'capitalImprovements',
        testId: 'capitalImprovements',
        store,
        standaloneLabel: false,
        addMarkForRequiredFields: true,
        isRequired: true
      })}
    </>
  );
});